

const facetLabelConversionMap = new Map([
    ["Category","فئة"],
    ["Brands","العلامات التجارية"],
    ["Product Type","نوع المنتج"],
    ["Gender","جنس"],
    ["Frame Color","لون الإطار"],
    ["Price","سعر"],
]);

const brandConversionMap = new Map([
    ["Prada", "برادا"],
    ["Ray-Ban", "راي بان"],
    ["Celine", "سيلين"],
    ["Gucci", "غوتشي"],
    ["Miu Miu", "ميو ميو"],
]);
const valueConversionMap = new Map([
    ["Ray-Ban", "راي بان"],
    ["RAY-BAN", "راي بان"],

    ["Prada", "برادا"],
    ["PRADA", "برادا"],

    ["Versace", "فيرساتشي"],
    ["VERSACE", "فيرساتشي"],

    ["Miu Miu", "ميو ميو"],
    ["MIU MIU", "ميو ميو"],

    ["Oakley", "أوكلي"],
    ["OAKLEY", "أوكلي"],

    ["Dolce & Gabbana", "دولتشي آند غابانا"],
    ["Dolce&Gabbana", "دولتشي آند غابانا"],

    ["Burberry", "بربري"],
    ["BURBERRY", "بربري"],

    ["Persol", "بيرسول"],
    ["PERSOL", "بيرسول"],

    ["Gucci", "غوتشي"],

    ["Prada Linea Rossa", "برادا لينيا روسا"],
    ["PRADA LINEA ROSSA", "برادا لينيا روسا"],

    ["Tiffany & Co.", "تيفاني آند كو"],
    ["TIFFANY", "تيفاني"],

    ["Giorgio Armani", "جورجيو أرماني"],
    ["Emporio Armani", "إمبوريو أرماني"],

    ["Oliver Peoples", "أوليفر بيبولز"],
    ["Tom Ford", "توم فورد"],
    ["Jimmy Choo", "جيمي تشو"],
    ["Saint Laurent", "سان لوران"],
    ["Celine", "سيلين"],
    ["Fendi", "فندي"],
    ["Michael Kors", "مايكل كورس"],
    ["Polo Ralph Lauren", "بولو رالف لورين"],
     ["Men", "رجال"],
    ["Women", "نساء"],
    ["Unisex", "للجنسين"],
    ["Kids", "أطفال"]
]);
const sortLabelConversionMap = new Map([
  ["FEATURED", "المميز"],
  ["BEST SELLING", "الأكثر مبيعًا"],
  ["PRICE, LOW TO HIGH", "السعر: من الأدنى إلى الأعلى"],
  ["PRICE, HIGH TO LOW", "السعر: من الأعلى إلى الأدنى"],
  ["NEWEST FIRST", "الأحدث أولاً"],
  ["OLDEST FIRST", "الأقدم أولاً"]
]);
const placeholderConversionMap = new Map([
        ["Search for Miu Miu", "ابحث عن ميو ميو"],
        ["Search for Prada", "ابحث عن برادا"],
        ["Search for Ray-Ban", "ابحث عن راي بان"],
        ["Search for Celine", "ابحث عن سيلين"],
        ["Search for Gucci", "ابحث عن غوتشي"]
    ]);
const initGridFromSession = () => {
    const savedCols = sessionStorage.getItem('wizzyGridCols') || '4'; // default = 4
    const selector = savedCols == 2 ? '.wizzy-small-grid' : '.wizzy-large-grid';

    updateGrid(savedCols, selector);
};

 document.addEventListener('click', function (e) {
        if (!e.target.closest('.product-quick-add')) return;
        const el = document.querySelector('.wizzy-autocomplete-wrapper');
        if (el) {
            setTimeout(() => {
            el.style.opacity = '0';
            el.style.zIndex = '0';
            }, 500); // 1 second delay
        }
        });

const updateGrid = (cols, activeSelector) => {
    // Update columns everywhere
    document.querySelectorAll('.wizzy-search-results .main-collection--grid')
        .forEach(el => el.setAttribute('data-columns', cols));

    // Reset all grid buttons
    document.querySelectorAll('.wizzy-small-grid, .wizzy-large-grid')
        .forEach(btn => btn.setAttribute('data-active', 'false'));

    // Set active on current
    document.querySelector(activeSelector)?.setAttribute('data-active', 'true');

    // Optional: persist
    sessionStorage.setItem('wizzyGridCols', cols);
};
function initAR(data){
    console.log("init AR");
        const isArabic = window.Shopify.locale === "ar";
        // !window.wizzyConfig.common.isOnProductViewPage
        if(window.Shopify.locale == "ar") {
             data.search.configs.general.searchEndpoint="/ar/pages/search";
             window.wizzyConfig.credentials = {
                "apiKey": "SDBaUlF1VFJHQW9mclg4dFlZbWZTRFA5T1JiWTlwR1o2bVFSZmRmV21keEhaNFUzUzlDYVBLemYyMjc2NjNzM0hiWW9qOGppdFU1WHRmdzdsWTl4TWI4aG1XTlhaQy9WZENVNm1Ka1BXNms9",
                "storeId": "fcf469a0291011f190cf0a0c8095feae"
            }

             if (data.search?.configs?.facets?.configs) {
            data.search.configs.facets.configs = data.search.configs.facets.configs.filter(item => {
                return isArabic 
                    ? !item.key.endsWith('_en') 
                    : !item.key.endsWith('_ar');
            });
            }
            data.search.configs.facets.configs.forEach(item => {
                if (facetLabelConversionMap.has(item.label)) {
                    item.label = facetLabelConversionMap.get(item.label);
                }

            });
            if (data.autocomplete?.configs?.defaultBehaviour?.suggestions?.defaultPool) {
                data.autocomplete.configs.defaultBehaviour.suggestions.defaultPool.forEach(item => {
                    if (brandConversionMap.has(item.value)) {
                        const arValue = brandConversionMap.get(item.value);
                        item.value = arValue;
                        item.valueHighlighted = arValue;
                    }
                });
            }
            data.search.configs.sorts.configs.forEach(item => {
                if (sortLabelConversionMap.has(item.label)) {
                    item.label = sortLabelConversionMap.get(item.label);
                }
            });
            if (data?.autocomplete?.searchBar?.animatedPlaceholders) {
                data.autocomplete.searchBar.animatedPlaceholders =
                data.autocomplete.searchBar.animatedPlaceholders.map(text => {
                    return placeholderConversionMap.get(text) || text;
                });
            }
            if(data.autocomplete && data.autocomplete.menu) {
                data.autocomplete.menu.brands.title = "العلامات التجارية";
                data.autocomplete.menu.categories.title = "فئات";
                data.autocomplete.menu.others.title = "عمليات البحث الشائعة";
                data.autocomplete.topProducts.title = "أعلى المنتجات";
                data.search.view.templates.literals.emptySearchResultPageTitle = "لم نتمكن من العثور على أي نتائج!";
            }
            document.body.classList.add("wizzy-ar-language");

        }
        else {
        // ✅ Non-Arabic → remove _ar facets
        if (data.search?.configs?.facets?.configs) {
            data.search.configs.facets.configs = data.search.configs.facets.configs.filter(item => {
                return !item.key.endsWith('_ar');
            });
        }
    }

}
window.onWizzyScriptLoaded = function() {
    window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.BEFORE_INIT, function(data) {
        window.wizzyConfig.common.lazyDOMConfig.contentDOMIdentifiers = ['#main_content'];
        window.wizzyConfig.filters.configs.layout = 'v1';
        window.wizzyConfig.filters.configs.keepOpenedInMobileAfterApply = true;
        window.wizzyConfig.search.configs.facets.showPriceInputRangeFields = true;
        window.wizzyConfig.store.currency.symbol = 'SR.\u00A0'
        initAR(data);
         
        return data;
    })

    window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.BEFORE_LAZY_INIT, function(data) {
        window.wizzyConfig.common.lazyDOMConfig.contentDOMIdentifiers = ['#main_content'];
        window.wizzyConfig.filters.configs.layout = 'v1';
        window.wizzyConfig.filters.configs.keepOpenedInMobileAfterApply = true;
        window.wizzyConfig.search.configs.facets.showPriceInputRangeFields = true;
        window.wizzyConfig.store.currency.symbol = 'SR.\u00A0'
        initAR(data);


        return data;
    })

    window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.BEFORE_SEARCH_EXECUTED, function(data) {
        data.facets.forEach((facet) => {
            // console.log(facet);
            if (facet.key == 'brands')
                facet.key = "product_vendor";
            // console.log(facet);

        })
        document.querySelector('.search--cancel')?.click();
        document.querySelectorAll('.shopify-section.section--image-with-text')?.forEach(el => el.style.opacity = '0');
        return data;
    })

    window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.PRODUCTS_CACHED_RESULTS_RENDERED, function(data) {
        initGridFromSession();
        return data;
    })

    window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.VIEW_RENDERED, function(data) {


        // Event bindings
        document.querySelector('.wizzy-small-grid')?.addEventListener('click', () => {
            updateGrid(2, '.wizzy-small-grid');
        });

        document.querySelector('.wizzy-large-grid')?.addEventListener('click', () => {
            updateGrid(4, '.wizzy-large-grid');
        });
        initGridFromSession();

        // Apply button → trigger .wizzy-filters-bg
        document.querySelector('button.filter--button.wizzy-apply-btn')?.addEventListener('click', () => {
            document.querySelector('.wizzy-filters-bg')?.click();
        });

        // Clear button → trigger a.wizzy-filters-clear-all
        document.querySelector('button.filter--button.wizzy-clear-btn')?.addEventListener('click', () => {
            document.querySelector('a.wizzy-filters-clear-all')?.click();
        });

        document.querySelector('.wizzy-navigation--active-clear')?.addEventListener('click', () => {
            document.querySelector('a.wizzy-filters-clear-all')?.click();
        });
        return data;
    })
    window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.AFTER_PRODUCTS_TRANSFORMED, function(data) {

        const isArabic = window.Shopify.locale === "ar";
        data?.forEach(product => {
             if (isArabic && product.url && !product.url.includes('/ar/')) {
                const url = new URL(product.url, window.location.origin);
                product.url = `${url.origin}/ar${url.pathname}`;
            }
            product?.attributes?.forEach(atr => {
                if (atr?.id === "product_handle") {
                    product.handle = atr?.values?.[0]?.value?.[0];
                }
            });
            product.isBestSeller = false
            product.isNewIn = false;
            product?.categories?.some(cat => {
                if (cat?.id === "bestsellers") {
                    product.isBestSeller = true;
                    return true; // stops loop
                }
                if (cat?.id === "new-in") {
                    product.isNewIn = true;
                    return true; // stops loop
                }
                if (cat?.id === "add-a-pair-and-save") {
                    product.isDiscountTag = true;
                    return true; // stops loop
                }
                return false;
            });
        });

        return data;
    }, 1);

    window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.AFTER_WIZZY_API_RESPONDED, function(data) {
        if(window.Shopify.locale == "ar"){
        data?.response?.payload?.facets?.forEach(facet => {
            if (facet.type === "list" && Array.isArray(facet.data)) {

                facet.data.forEach(item => {
                    if (valueConversionMap.has(item.label)) {
                        item.label = valueConversionMap.get(item.label);
                    }
                });

            }

        });
        }
        return data;
    }, 1);


}